"use client";

import { connectorsForWallets } from "@rainbow-me/rainbowkit";
import {
  frameWallet,
  injectedWallet,
  metaMaskWallet,
  okxWallet,
  rainbowWallet,
  trustWallet,
  walletConnectWallet,
  zerionWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { promMainnet } from "config/default";
import { fallback } from "viem";
import { createConfig, createStorage, http } from "wagmi";
import { arbitrum, bsc, mainnet, optimism, polygon } from "wagmi/chains";

declare module "wagmi" {
  interface Register {
    config: typeof wagmiConfig;
  }
}

const connectors = connectorsForWallets(
  [
    {
      groupName: "Popular",
      wallets: [
        metaMaskWallet,
        injectedWallet,
        rainbowWallet,
        zerionWallet,
        trustWallet,
        frameWallet,
        okxWallet,
        walletConnectWallet,
      ],
    },
  ],
  {
    appName: "Prom",
    projectId: process.env.NEXT_PUBLIC_WALLET_CONNECT_ID as string,
  }
);

export const wagmiConfig = createConfig({
  connectors,
  chains: [promMainnet, mainnet, bsc, arbitrum, optimism, polygon],
  transports: {
    [promMainnet.id]: http("https://rpc.prom.io"),
    [mainnet.id]: fallback([
      http("https://ethereum-rpc.publicnode.com"),
      http("https://eth.llamarpc.com"),
      http("https://cloudflare-eth.com"),
    ]),
    [bsc.id]: fallback([
      http("https://bsc-dataseed.binance.org"),
      http("https://bsc.blockrazor.xyz"),
      http("https://bsc-rpc.publicnode.com"),
      http("https://bsc.drpc.org"),
    ]),
    [optimism.id]: http("https://optimism-rpc.publicnode.com"),
    [arbitrum.id]: http("https://arbitrum-one-rpc.publicnode.com"),
    [polygon.id]: http("https://polygon-bor-rpc.publicnode.com"),
  },
  storage: createStorage({
    storage: typeof localStorage === "undefined" ? undefined : localStorage,
    key: "prom-1.0.2",
  }),
  ssr: true,
});

export type ChainId = (typeof wagmiConfig)["chains"][number]["id"];
